module.exports = __webpack_public_path__ + "shell/assets/images/vendor/shibboleth.svg";